import { useQuery } from '@tanstack/react-query';

import { api } from '@/lib/api';
import { queryKeys } from '@/lib/query-keys';

// The current account's own profile, shared by every screen that reads
// it (threads list, thread-detail, profile, profile-photos,
// profile-prompts). This is the one place carrying the query's policy:
// retry: false because a 404 here means "no Profile yet" -- a stable
// outcome (the create path), not a transient failure worth TanStack's
// default 3-attempt backoff, which would delay the "create a profile"
// CTA for several seconds on every cold start.
export function useMyProfile() {
  return useQuery({
    queryKey: queryKeys.meProfile(),
    queryFn: api.getOwnProfile,
    retry: false,
  });
}
